import Constants from "~/helpers/enums/Constants";

const initialState = {
	couponService: null,
};

const couponServicesReducer = (state = initialState, action = null) => {
	switch (action.type) {
		case Constants.GET_COUPON_SERVICE:
			return {
				...state,
				couponService: action.payload.couponService,
			};
		default:
			return state;
	}
};

export default couponServicesReducer;
// professional services